import axios from 'axios';

import queryString from '../../utils/queryString';
import { headers, salesServiceUrl } from '../../config';

export function getPayment({id}) {
    return axios.get(`${salesServiceUrl}/payments/${id}`, {headers: headers()});
}

export function getPaymentsList(payload = {}) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/payments?${query}`, { headers: headers() });
}

export function storePayment({data, dpk}) {
    return axios.post(`${salesServiceUrl}/payments`, data, { headers: {...headers(), Dpk: dpk} });
}

export function updatePayment({id, data}) {
    return axios.put(`${salesServiceUrl}/payments/${id}`, data, { headers: headers() });
}

export function simulatePayment({paymentId}) {
    return axios.get(`${salesServiceUrl}/payments/${paymentId}/simulate`, { headers: headers() });
}

export function postPaymentToLedger({id, dpk}) {
    return axios.post(`${salesServiceUrl}/payments/${id}/post`, {}, { headers: {...headers(), Dpk: dpk} });
}